import React from 'react';
import { Container, Box, Paper, Typography, useTheme } from '@mui/material';
import LoginForm from '../components/auth/LoginForm';
import PageTitle from '../components/PageTitle';

/**
 * Login page component
 * @returns {JSX.Element} Login page
 */
const LoginPage = () => {
  const theme = useTheme();
  const logoUrl = `${process.env.PUBLIC_URL}/images/logo.png`;
  
  return (
    <Container maxWidth="sm" 
      sx={{ 
        height: '100vh', 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        py: 2 
      }}
    >
      <PageTitle title="Login" />
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          mb: 4 
        }}
      >
        <img 
          src={logoUrl}
          alt="Juhari Trading Logo" 
          style={{ 
            height: '80px', 
            width: '80px',
            marginBottom: '16px',
            objectFit: 'contain'
          }} 
        />
        <Typography 
          variant="h4" 
          component="h1" 
          align="center" 
          color="primary"
          sx={{ fontWeight: 500 }}
        >
          JuhariTrading
        </Typography>
        <Typography 
          variant="subtitle1" 
          align="center" 
          color="text.secondary"
        >
          Business Inventory Management System
        </Typography>
      </Box>
      
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          display: 'flex', 
          flexDirection: 'column', 
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}
      >
        <LoginForm />
      </Paper>
      
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} JuhariTrading. All rights reserved.
        </Typography>
      </Box>
    </Container>
  );
};

export default LoginPage; 